import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-[#3C2415]">
      <div className="max-w-7xl mx-auto text-center">
        <h3 className="text-2xl font-bold mb-2">
          <span className="text-white">Spend</span>
          <span className="text-[#6B7A5C]">Less</span>
        </h3>
        <p className="text-[#A89884] mb-4">
          Spend Less. Live More.
        </p>
        <div className="flex items-center justify-center gap-4 text-sm">
          <Link to="/blog" className="text-[#A89884] hover:text-[#D4C7B8] transition-colors">Blog</Link>
          <span className="text-[#5A4030]">|</span>
          <Link to="/products/community" className="text-[#A89884] hover:text-[#D4C7B8] transition-colors">Community</Link>
          <span className="text-[#5A4030]">|</span>
          <Link to="/access" className="text-[#A89884] hover:text-[#D4C7B8] transition-colors">My Guides</Link>
          <span className="text-[#5A4030]">|</span>
          <Link to="/free-guide" className="text-[#A89884] hover:text-[#D4C7B8] transition-colors">Free Guide</Link>
          <span className="text-[#5A4030]">|</span>
          <Link to="/unsubscribe" className="text-[#A89884] hover:text-[#D4C7B8] transition-colors">Unsubscribe</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
